"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchRecoveryProfitQuery = exports.useFetchSupplierCostByChargeQuery = exports.useFetchSupplierBillsQuery = exports.supplierBillApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var reportingParams = function (obj) {
    var _a;
    return (__assign(__assign(__assign(__assign({ clientId: obj.clientId }, (obj.buildingId ? { buildingId: obj.buildingId } : {})), (obj.from ? { from: obj.from } : {})), (obj.to ? { to: obj.to } : {})), { granularity: (_a = obj.granularity) !== null && _a !== void 0 ? _a : "month" }));
};
exports.supplierBillApi = (0, react_1.createApi)({
    reducerPath: "supplierBillApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["supplier_bills"],
    endpoints: function (builder) { return ({
        fetchSupplierBills: builder.query({
            query: function (obj) { return ({
                url: "/v1/supplier-bill/all",
                method: "GET",
                params: __assign(__assign(__assign({ clientId: obj.clientId }, (obj.buildingId ? { buildingId: obj.buildingId } : {})), (obj.from ? { from: obj.from } : {})), (obj.to ? { to: obj.to } : {})),
            }); },
            providesTags: ["supplier_bills"],
        }),
        fetchSupplierCostByCharge: builder.query({
            query: function (obj) { return ({ url: "/v1/supplier-bill/cost-by-charge", method: "GET", params: reportingParams(obj) }); },
            providesTags: ["supplier_bills"],
        }),
        fetchRecoveryProfit: builder.query({
            query: function (obj) { return ({ url: "/v1/supplier-bill/recovery-profit", method: "GET", params: reportingParams(obj) }); },
            providesTags: ["supplier_bills"],
        }),
    }); },
});
exports.useFetchSupplierBillsQuery = exports.supplierBillApi.useFetchSupplierBillsQuery, exports.useFetchSupplierCostByChargeQuery = exports.supplierBillApi.useFetchSupplierCostByChargeQuery, exports.useFetchRecoveryProfitQuery = exports.supplierBillApi.useFetchRecoveryProfitQuery;
